import React,{Fragment} from 'react'
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const CountContent = [
    {
        mark: '',
        num: 63,
        text: '%',
        desc: 'AI is needed to make us more well-informed',
        desc2: 'while reducing the 63% of non-selling time',
    },
    {
        mark: '',
        num: 1,
        text: 'b+',
        desc: 'If you are looking to reach',
        desc2: 'more than +1 Billion in growth revenue',
    },
    {
        mark: '+',
        num: 50,
        text: '%',
        desc: 'Sales teams that have adopted AI ',
        desc2: 'have increased leads by more than 50%',
    }
]

const CommonCounter = () => {
    return ( 
    <Fragment> 
        <div className="row justify-content-center">
            {CountContent.map((val, i)=>(
                <div
                key={i}
                className="col-md-4 col-sm-6"
                data-aos="fade-up"
                data-aos-delay={val.dataDelay}>
                <div className="counter-block-one text-center mb-20">
                    <div className="main-count">
                        <span className="counter">{val.mark}
                            <CountUp start={0} end={val.num} duration={1}>
                                {({countUpRef, start}) => (
                                    <VisibilitySensor onChange={start}>
                                        <span ref={countUpRef}/>
                                    </VisibilitySensor>
                                )}
                            </CountUp>
                        </span>{val.text}</div>
                    <p>{val.desc} <br/>{val.desc2}</p>
                </div>
            </div>
            ))}
        </div> 
    </Fragment>

    )}

export default CommonCounter